import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ id, value, onChange, testid, className, autoComplete = "current-password", placeholder, required = true, minLength }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? "text" : "password"}
        required={required}
        minLength={minLength}
        data-testid={testid}
        className={`${className} pr-14`}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        data-testid={`${testid}-toggle`}
        className="absolute right-1 top-1/2 -translate-y-1/2 h-11 w-11 min-h-[44px] min-w-[44px] rounded-lg flex items-center justify-center text-slate-500 hover:text-navy hover:bg-cream-dark/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/40 transition-colors"
      >
        {visible ? <EyeOff className="w-5 h-5" strokeWidth={2} /> : <Eye className="w-5 h-5" strokeWidth={2} />}
      </button>
    </div>
  );
}
